export const ROUTES = {
    ROUTE_PATH_HOMEPAGE: "/home",
    ROUTE_PATH_EXPLOREPAGE: "/explore",
    ROUTE_PATH_BOOKMARKPAGE: "/bookmark",
    ROUTE_PATH_POSTPAGE: "/post/:userID/:postID",
    ROUTE_PATH_LANDINGPAGE: "/",
    ROUTE_PATH_Unknown: "*",
    ROUTE_PATH_LoginPage: "/login",
    ROUTE_PATH_SignupPage: "/signup",
    ROUTE_PATH_ProfilePage: "/profile/:userID",
    ROUTE_PATH_MOCKMAN :"/mockman",
    VAR_ENCODE_TOKEN: "BuzzToken",
    VAR_USER_ID: "BuzzUserId",
    VAR_USER_DETAILS: "BuzzUserDetails",
  };